export const reSiteName = /^(?=.{5,}$)[\p{L}\p{N} ]+$/u;
export const reStreet = /^(?! )[A-Za-z0-9 .'-]{3,}(?<! )\s+\d+[A-Za-z]?$/; // "Street Name 12" style
export const rePostal = /^[A-Za-z0-9][A-Za-z0-9\s-]{2,10}$/; // generic postal
export const reCountry = /^(?! )[A-Za-z][A-Za-z -]{1,}(?<! )$/; // ≥2 letters, no trailing spaces
export const reEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/; // simple email
export const rePersonOrCompany = /^(?! )[A-Za-z0-9&.,' -]{2,}(?<! )$/; // names with &,.,'-

export const validateSiteForm = (values = {}) => {
  const v = {
    name: (values.name || "").trim(),
    street: (values.street || "").trim(),
    postalCode: (values.postalCode || "").trim(),
    country: (values.country || "").trim(),
    clientEmail: (values.clientEmail || "").trim(),
    clientName: (values.clientName || "").trim(),
  };

  const errors = {};

  if (!reSiteName.test(v.name))
    errors.name = "Enter a valid site name (≥5 chars, letters/numbers/spaces).";

  if (!reStreet.test(v.street))
    errors.street = "Enter a valid street (e.g., 'Main Street 12').";

  if (!rePostal.test(v.postalCode))
    errors.postalCode = "Enter a valid postal code.";

  if (!reCountry.test(v.country))
    errors.country = "Enter a valid country name.";

  if (!reEmail.test(v.clientEmail))
    errors.clientEmail = "Enter a valid email address.";

  if (!rePersonOrCompany.test(v.clientName))
    errors.clientName = "Enter a valid client/company name.";

  ["name", "street", "postalCode", "country", "clientEmail", "clientName"].forEach((k) => {
    if (!v[k]) errors[k] = "This field is required.";
  });

  return errors;
};